import axios from 'axios';
import { getUserFromLS } from '../../utils/getUserFromLS';
import { ICalendarAccountInsight } from '../../Types/calendar';
import { getTutorialAccountInsight } from '../tutorialFixtureResponses';

export const getAccountInsight = (
  insightId: string,
  callback: (response: ICalendarAccountInsight) => void,
  errorCallback: (error: any) => void
) => {
  const fixture = getTutorialAccountInsight(insightId);
  if (fixture) {
    if (callback != null) {
      callback(fixture);
    }
    return Promise.resolve(fixture);
  }

  const user = getUserFromLS();
  const URL = `${import.meta.env.VITE_API_BASE_URL}/account_insights/${insightId}`;

  return axios(URL, {
    method: "GET",
    headers: {
      Authorization: `Bearer ${user.access_token}`
    }
  })
    .then((response) => {
      if (callback != null) {
        callback(response.data as ICalendarAccountInsight);
      }
    })
    .catch((error) => {
      console.error('Error fetching account insight:', error);
      if (errorCallback != null) {
        errorCallback(error);
      }
    });
};
